import MergedMarker from "./MergedMarker";
import SingleMarker from "./SingleMarker";
import { MarkerDataType } from "../../GoogleMapContainer";
import { checkingMergedSystem } from "utils/DashboardUtil";

export default function DefaultMarker(props: MarkerDataType): JSX.Element {
  const isMerged = checkingMergedSystem(props.groupingSystems);
  if (isMerged) {
    return <MergedMarker {...props} />;
  }

  return <SingleMarker {...props} />;
}
